import actions from './constants';

export const showSaveCollection = (category, code) => ({
  type: actions.SHOW_SAVE_COLLECTION,
  category,
  code,
});

export const hideSaveCollection = () => ({
  type: actions.HIDE_SAVE_COLLECTION,
});

export const updateCollectionProperties = (category, code, properties) => ({
  type: actions.UPDATE_COLLECTION_PROPERTIES,
  category,
  code,
  properties,
});

export const updateActiveCollectionProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_COLLECTION_PROPERTIES,
  properties,
});

export const updateCollectionCancel = (category, code) => ({
  type: actions.UPDATE_COLLECTION_CANCEL,
  category,
  code,
});

export const fetchCollections = (category, page, pageSize, append) => ({
  type: actions.FETCH_COLLECTIONS,
  category,
  page,
  pageSize,
  append,
});

export const refreshCollections = (category, page) => ({
  type: actions.REFRESH_COLLECTIONS,
  category,
  page,
});

export const toggleCollectionSelected = (category, code) => ({
  type: actions.TOGGLE_COLLECTION_SELECTED,
  category,
  code,
});

export const toggleCollectionsSelected = (category, selected) => ({
  type: actions.TOGGLE_COLLECTIONS_SELECTED,
  category,
  selected,
});

export const updateCollectionsFilter = (category, value) => ({
  type: actions.UPDATE_COLLECTIONS_FILTER,
  category,
  value,
});

export const showCollectionsResults = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_COLLECTIONS_RESULTS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showCollectionsError = (category, error) => ({
  type: actions.SHOW_COLLECTIONS_ERROR,
  category,
  error,
});

export const closeCollections = ({ category }) => ({
  type: actions.CLOSE_COLLECTIONS,
  category,
});

export const closeCollection = ({ category, code }) => ({
  type: actions.CLOSE_COLLECTION,
  category,
  code,
});

export const fetchCollection = (category, code, isNew) => ({
  type: actions.FETCH_COLLECTION,
  category,
  code,
  isNew,
});

export const showCollection = (category, code, result, isNew) => ({
  type: actions.SHOW_COLLECTION,
  category,
  code,
  result,
  isNew,
});

export const showCollectionError = (category, code, error) => ({
  type: actions.SHOW_COLLECTION_ERROR,
  category,
  code,
  error,
});

export const createCollection = () => ({
  type: actions.CREATE_COLLECTION,
});

export const newCollection = (category, code, result) => ({
  type: actions.NEW_COLLECTION, category, code, result,
});

export const newCollectionError = (error) => ({
  type: actions.NEW_COLLECTION_ERROR,
  error,
});

export const updateCollection = (category, code, properties) => ({
  type: actions.UPDATE_COLLECTION,
  category,
  code,
  properties,
});

export const editCollection = (category, code) => ({
  type: actions.EDIT_COLLECTION,
  category,
  code,
});

export const updateCollectionSuccess = (code, result) => ({
  type: actions.UPDATE_COLLECTION_SUCCESS,
  code,
  result,
});

export const updateCollectionError = (category, code, error) => ({
  type: actions.UPDATE_COLLECTION_ERROR,
  category,
  code,
  error,
});

export const confirmCollectionDeletion = (category, code) => ({
  type: actions.SHOW_DELETE_COLLECTION,
  category,
  code,
});

export const confirmCollectionsDeletion = (category) => ({
  type: actions.SHOW_DELETE_COLLECTIONS,
  category,
});

export const deleteCollection = ({ items }) => ({
  type: actions.DELETE_COLLECTION,
  items,
});

export const destroyCollection = (items, silent) => ({
  type: actions.DESTROY_COLLECTION, items, silent,
});

export const destroyCollectionError = (items) => ({
  type: actions.DESTROY_COLLECTION_ERROR, items,
});

export const hideDeleteCollection = () => ({
  type: actions.HIDE_DELETE_COLLECTION,
});

export const checkCollectionImage = (category, code, uppyId) => ({
  type: actions.CHECK_COLLECTION_IMAGE,
  category,
  code,
  uppyId,
});

export const saveCollectionImage = (category, code) => ({
  type: actions.SAVE_COLLECTION_IMAGE,
  category,
  code,
});

export const saveCollectionImageSuccess = (code, imageKey) => ({
  type: actions.SAVE_COLLECTION_IMAGE_SUCCESS,
  code,
  imageKey,
});

export const resetCollectionImage = (category, code, uppyId) => ({
  type: actions.RESET_COLLECTION_IMAGE,
  category,
  code,
  uppyId,
});

export const saveCollectionImageError = (category, code, error) => ({
  type: actions.SAVE_COLLECTION_IMAGE_ERROR,
  category,
  code,
  error,
});

export const toggleCollectionsSingleSorting = (category) => ({
  type: actions.TOGGLE_COLLECTIONS_SINGLE_SORTING,
  category,
});

export const toggleCollectionsColumnOrderBy = (category, orderByColumn) => ({
  type: actions.TOGGLE_COLLECTIONS_COLUMN_ORDER_BY,
  category,
  orderByColumn,
});

export const toggleCollectionsPresentation = (category, display) => ({
  type: actions.TOGGLE_COLLECTIONS_PRESENTATION,
  category,
  display,
});
